import { AppIcon, RawSVG } from 'core/components/icons/icon.type';

export const iconMenu: AppIcon = {
  svgData: '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.0038 5.9975H2.99628" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M6.99795 12H21.0038" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M21.0038 18.0025H10.9996" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' as RawSVG,
  name: 'menu',
};
